import {
    EventEmitter,    Input,
    Output,
    TemplateRef,
    ViewChild,
} from "@angular/core";
import { Layout } from "./layout";

export abstract class Editor extends Layout {
    // properties
    showPlaceholder: boolean = true;

    // io
    @Input() label: string;
    @Input() placeholder: string;

    private _value: any = '';
    get value(): any {
        return this._value;
    }
    @Input() set value(value: any) {
        this._value = value;
        this.showPlaceholder = this.value === '';
        this.onValueChanged.emit(this.value);
    }

    @Output() onValueChanged: EventEmitter<any> = new EventEmitter<any>();
}



// WEBPACK FOOTER //
// ./client-src/app/core/baseObjects/input.ts